export enum ServicesTypes {
  FUNDOS = 'FUNDOS',
  CONTA_ESCROW_TITULAR = 'CONTA_ESCROW_TITULAR',
  BANCO_LIQUIDANTE_TITULAR = 'BANCO_LIQUIDANTE_TITULAR',
  CONTA_ESCROW_PARTES_RELACIONADAS = 'CONTA_ESCROW_PARTES_RELACIONADAS',
  BANCO_LIQUIDANTE_PARTES_RELACIONADAS = 'BANCO_LIQUIDANTE_PARTES_RELACIONADAS'
}
